import Event from './event';
import BaseModel from './base';

import Hall from './exhibition-hall';

import User from '@/utils/user.js';

/**
 * Модель выставки мероприятия
 */
export default class Exhibition extends BaseModel {
  #user;

  constructor(item, url) {
    super(item, url);

    this.description = item.description || '';
    this.is_active = item.is_active || false;
    this.event_id = item.event_id;
    this.owner_id = item.owner_id;

    // expand: events,halls,owner,image

    this.image = item.image || null;

    this.owner = item.owner || null;

    this.events = (item.events || []).map((event) => new Event(event));

    this.halls = (item.halls || []).map((hall) => new Hall(hall));

    this.#user = new User();
  }

  get isOwner() {
    return this.#user.data?.id === this.owner_id;
  }

  get hallsCount() {
    return this.halls.length;
  }
}
